import { v4 as uuid } from "uuid";

import type { MediaContextShape } from "../../../media";
import type {
  BibleManifest,
  BibleTranslations,
  QueueContextShape,
  QueueItem,
  QueueManagedPrayerItem,
} from "../../src";

export const MOCK_PLAYER: MediaContextShape = {
  addToQueue: () => Promise.resolve([]),
  autoResumed: false,
  bgId: null,
  bgTitle: null,
  bgVolume: 0.25,
  cancelSleepTimer: () => {},
  currentTime: 100,
  display: "collapsed",
  duration: 300,
  goToQueueId: () => Promise.resolve(),
  inTransition: false,
  mediaRef: { current: null },
  mediaType: "audio",
  pause: () => {},
  paused: true,
  play: () => Promise.resolve(),
  playNew: () => Promise.resolve(),
  restart: () => {},
  setBgId: () => {},
  setBgVolume: () => {},
  setSleepTimer: () => {},
  setSpeed: () => {},
  setSubtitles: () => {},
  setTime: () => {},
  setVolume: () => {},
  skipBack: () => {},
  skipForward: () => Promise.resolve(),
  skipIntro: () => {},
  sleepTimerStart: 0,
  sleepTimerTarget: 0,
  speed: 1,
  subtitleIdx: null,
  subtitles: [],
  switchTo: () => Promise.resolve(),
  tosTrigger: null,
  volume: 1,
};
export const MOCK_PLAYER_VIDEO: MediaContextShape = {
  addToQueue: () => Promise.resolve([]),
  autoResumed: false,
  bgId: null,
  bgTitle: null,
  bgVolume: 0.25,
  cancelSleepTimer: () => {},
  currentTime: 100,
  display: "expanded",
  duration: 300,
  goToQueueId: () => Promise.resolve(),
  inTransition: false,
  mediaRef: { current: null },
  mediaType: "video",
  pause: () => {},
  paused: true,
  play: () => Promise.resolve(),
  playNew: () => Promise.resolve(),
  restart: () => {},
  setBgId: () => {},
  setBgVolume: () => {},
  setSleepTimer: () => {},
  setSpeed: () => {},
  setSubtitles: () => {},
  setTime: () => {},
  setVolume: () => {},
  skipBack: () => {},
  skipForward: () => Promise.resolve(),
  skipIntro: () => {},
  sleepTimerStart: 0,
  sleepTimerTarget: 0,
  speed: 1,
  subtitleIdx: null,
  subtitles: [],
  switchTo: () => Promise.resolve(),
  tosTrigger: null,
  volume: 1,
};

export const mockQueueItem: QueueManagedPrayerItem = {
  collection: {
    available_at: null,
    desc: "Join us this upcoming Lenten season as we follow Christ and deepen our relationship with Him. Stay tuned for exciting announcements about our Pray40 theme and the guests who'll be leading us in prayer and meditation.",
    ends_at: null,
    has_access: true,
    has_high_res_illo: true,
    id: 1438,
    images: {
      color_hex: "#2B1232",
      large: "https://images.hallow.app/covers/1438_l.webp",
      medium: null,
      small: "https://images.hallow.app/covers/1438_s.webp",
    },
    is_album: false,
    is_completed: false,
    paid: true,
    prayers_count: 47,
    sessions: "47 sessions",
    short_desc: "Lent Pray40 Challenge",
    supertitle: "CHALLENGES",
    title: "Lent Pray40",
    type: "default",
  },
  prayer: {
    collection_id: 1438,
    detailed_desc: "-",
    guides: [
      {
        deeplink: null,
        desc: "Abby is a founding member of Hallow, a wife, and a mother.",
        id: 1,
        image_url: "https://images.hallow.app/guides/abby_150.png",
        images: {
          large: "https://images.hallow.app/guides/abby_150.png",
          medium: "https://images.hallow.app/guides/abby_150.png",
          small: "https://images.hallow.app/guides/abby_150.png",
        },
        name: "Abby",
        sample_audio_url: null,
        tagline: "Casual and Warm",
      },
      {
        deeplink: null,
        desc: "Francis is a founding member of Hallow and has five years of seminary formation.",
        id: 2,
        image_url: "https://images.hallow.app/guides/francis_150.png",
        images: {
          large: "https://images.hallow.app/guides/francis_150.png",
          medium: "https://images.hallow.app/guides/francis_150.png",
          small: "https://images.hallow.app/guides/francis_150.png",
        },
        name: "Francis",
        sample_audio_url:
          "https://audio-dev.hallow.app/Samples%20-%20F.mp3?Expires=1708067526&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=HqJC8v7Cwfryem3ldUCj99LnwjgqkW6xLJVBwiKVlfWAbNSBl4v9E5xzJnKosiJppLkvkMM3BJ-zz6sLfCST8u%7E4n%7E3SGPt2hzcXI3LJL8AZNKewqi6hX1QnP8cMG4lUC-kZWsKJ8I%7ErSQnesGr%7ELwHlX3EgAxzFFwqRyQFhANClLuPb%7EFC3mqX0lwqqnwk2N62X8cxrDAkatm764CjJ9LHJ2K4QAG%7EcyB24y3hkonHtKYxHIkd1g2p8qQf2NjXQCFrH6uyH4KeSX6N-AGZyzDmlOmbNwX8FANpl1mUMhMsKnY8g65tSwuxUn%7EOV6lC6OIGbEpm-P5jX10iOGNhQBQ__",
        tagline: "Deliberate and Calm",
      },
      {
        deeplink: null,
        desc: 'Jonathan is a trained voice actor, who portrays Jesus in the hit TV series "The Chosen."',
        id: 3,
        image_url: "https://images.hallow.app/guides/jonathan_150.png",
        images: {
          large: "https://images.hallow.app/guides/jonathan_150.png",
          medium: "https://images.hallow.app/guides/jonathan_150.png",
          small: "https://images.hallow.app/guides/jonathan_150.png",
        },
        name: "Jonathan",
        sample_audio_url: null,
        tagline: "Heartfelt and Engaging",
      },
    ],
    has_access: true,
    id: 1037204,
    images: {
      color_hex: "#2B1232",
      large: "https://images.hallow.app/covers/1438_l.webp",
      medium: "https://images.hallow.app/covers/1438_m.webp",
      small: "https://images.hallow.app/covers/1438_s.webp",
    },
    is_available: true,
    is_completed: false,
    is_download_enabled: true,
    is_favorite: false,
    is_redeemed: false,
    is_song: false,
    label_desc: "Thursday: February 15",
    lengths: "5 min",
    order: 2,
    prompt: "This is an prompt 2",
    shareable_quote: null,
    shareable_url: "https://hallow.com/prayers/1037204",
    supertitle: "CHALLENGES",
    title: "Day 2",
    tracks: [
      {
        duration: 300,
        guide_id: 2,
        id: 94389,
        length: "5 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 300,
        guide_id: 1,
        id: 94390,
        length: "5 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 300,
        guide_id: 3,
        id: 94391,
        length: "5 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 600,
        guide_id: 1,
        id: 94392,
        length: "10 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 600,
        guide_id: 2,
        id: 94393,
        length: "10 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 600,
        guide_id: 3,
        id: 94394,
        length: "10 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 900,
        guide_id: 1,
        id: 94395,
        length: "15 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 900,
        guide_id: 2,
        id: 94396,
        length: "15 min",
        paid: false,
        prayer_id: 1037204,
      },
      {
        duration: 900,
        guide_id: 3,
        id: 94397,
        length: "15 min",
        paid: false,
        prayer_id: 1037204,
      },
    ],
  },
  selected_audio: {
    bg_sounds_enabled: true,
    duration: 300,
    guide_id: 2,
    hls: {
      cookies: [],
      url: "https://images.hallow.app/audio/web-app-test/aa52fc59-bb5a-4401-ad9b-3c9bcec1e0af/aa52fc59-bb5a-4401-ad9b-3c9bcec1e0af_HLS_256kb.m3u8",
    },
    id: 94389,
    intro_ends_at: 47000,
    length: "5 min",
    paid: false,
    pauses: [],
    prayer_id: 1037204,
    resumes_at: 183923,
    resumes_session_id: null,
    show_music_controls: false,
    speed_changes_enabled: true,
    url: "https://images.hallow.app/audio/web-app-test/aa52fc59-bb5a-4401-ad9b-3c9bcec1e0af/aa52fc59-bb5a-4401-ad9b-3c9bcec1e0af.m4a",
  },
  uuid: "some-random-string",
  errored: false,
};

const makeQueueItems = (
  singleMock: QueueManagedPrayerItem,
  num: number,
  add: boolean = true,
): QueueManagedPrayerItem[] => {
  const arr: QueueManagedPrayerItem[] = [];

  let lastItem = singleMock;

  for (let i = 0; i < num; i++) {
    const newItem = structuredClone(lastItem);
    if (add) {
      newItem.prayer.id++;
      newItem.selected_audio.id++;
      newItem.prayer.title = `Day ${2 + i + 1}`;
      for (let j = 0; j < newItem.prayer.tracks.length; j++) {
        newItem.prayer.tracks[j].prayer_id++;
        newItem.prayer.tracks[j].id += j + 1;
      }
    } else {
      newItem.prayer.id--;
      newItem.selected_audio.id--;
      newItem.prayer.title = `Day ${2 - (i + 1)}`;
      for (let j = 0; j < newItem.prayer.tracks.length; j++) {
        newItem.prayer.tracks[j].prayer_id--;
        newItem.prayer.tracks[j].id -= j + 1;
      }
    }
    newItem.uuid = uuid();
    newItem.errored = false;

    arr.push(newItem);
    lastItem = newItem;
  }

  return arr;
};

const mockPast = makeQueueItems(mockQueueItem, 3, false);
const mockFuture = makeQueueItems(mockQueueItem, 15);

export const MOCK_QUEUE: QueueContextShape = {
  addToQueue: () => new Promise(() => {}),
  back: () => null,
  clearQueue: () => {
    MOCK_QUEUE.fullQueue = [];
    MOCK_QUEUE.upcomingQueue = [];
    MOCK_QUEUE.pastQueue = [];
    MOCK_QUEUE.currentItem = null;
    MOCK_QUEUE.position = null;
  },
  currentItem: mockQueueItem,
  dailySkipsRemaining: 10,
  delete: (uuid: string) =>
    MOCK_QUEUE.newQueue({
      items: MOCK_QUEUE.fullQueue
        .filter((qi) => qi.uuid !== uuid)
        .map((qi) => ({ id: qi.selected_audio.id, type: "audio" })),
    }),
  forward: () => null,
  fullQueue: [...mockPast, mockQueueItem, ...mockFuture],
  hourlySkipsRemaining: 10,
  loading: false,
  localReorder: () => {},
  newQueue: (q) =>
    new Promise<QueueManagedPrayerItem[]>((resolve) => {
      const replacementItems = [...MOCK_QUEUE.fullQueue];
      const newQueue: QueueManagedPrayerItem[] = [];
      for (const qi of q.items) {
        const itm = replacementItems.find(
          (ri) => ri.selected_audio.id === qi.id,
        );
        if (itm) newQueue.push(itm as QueueManagedPrayerItem);
      }
      MOCK_QUEUE.fullQueue = newQueue;
      const split = newQueue.findIndex(
        (qi) => qi.uuid === MOCK_QUEUE.currentItem?.uuid,
      );
      MOCK_QUEUE.pastQueue = newQueue.slice(0, split);
      MOCK_QUEUE.upcomingQueue = newQueue.slice(split + 1);
      resolve(newQueue);
    }),
  pastQueue: mockPast,
  position: 3,
  refresh: () => Promise.resolve(),
  repeat: () => "none",
  repeating: "none",
  shuffle: () => false,
  shuffled: false,
  skipTo: () => null,
  swap: () => Promise.resolve(),
  upcomingQueue: mockFuture,
};

export const MOCK_EMPTY_QUEUE: QueueContextShape = {
  addToQueue: () => new Promise(() => []),
  back: () => null,
  clearQueue: () => {},
  currentItem: mockQueueItem,
  dailySkipsRemaining: 10,
  delete: () => {},
  forward: () => null,
  fullQueue: [mockQueueItem],
  hourlySkipsRemaining: 10,
  loading: false,
  localReorder: () => {},
  newQueue: () => Promise.resolve([]),
  pastQueue: [],
  position: null,
  refresh: () => Promise.resolve(),
  repeat: () => "none",
  repeating: "none",
  shuffle: () => false,
  shuffled: false,
  skipTo: () => null,
  swap: () => Promise.resolve(),
  upcomingQueue: [],
};

export const MOCK_BACKGROUND_SOUNDS: QueueItem[] = [
  {
    selected_audio: {
      id: 10841,
      prayer_id: 10166,
      guide_id: 71,
      length: "30 min",
      duration: 1805,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Piano.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=XoeTmTfJbuDjeg7HKnqR%7EolTRuEczGJpAR7vKAUobVALnSXaPzA-MRRYXoMYsAoxTyW7gqLlAC6lnJw1QJAoQmY5lo6KwEDW992ipk6gFk4oABqD8I6F6vmo90SJsd40tHJObKkmLMTCyFHkJgScqzBNwHLLF3GM98p71%7EZ5fjky1N7V43pcm4JoSKOMHw0RtylVzm0S7mBzj1U7da6l-8HL0VUW6kWFCgZB9NdOrJxOmSolUK9HQ7UCsBUGMC7ZHQHscN2jXr5BeEqReBNbBH2%7EWLIk7s0I7NYFwe8RNjVopTeXxTBNjqQhWsZO0ShRJ9GHkAiE7zsy8zgm5lY8Zg__",
      hls: null,
    },
    prayer: {
      id: 10166,
      collection_id: 100,
      title: "Light Piano",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10841,
          prayer_id: 10166,
          guide_id: 71,
          length: "30 min",
          duration: 1805,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 1,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30 min",
      shareable_url: "https://hallow.com/prayers/10166",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10833,
      prayer_id: 10162,
      guide_id: 71,
      length: "30 min",
      duration: 1800,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Chant-Sanctus.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=bgNOwgrE9DdYsJcKvkvYkCYUjbLv-%7EmOIeMhI9ah5uOQUyfM%7E3nZ-3v2yN3bsdnutw4ycHXizC9-fGcLPRDYBT2JCml3Enxz7%7Es9McDU%7E0b9x9q%7E7PQJPRiIoXYMaYC6qNwtnyxbvgXL2sDmjywRo0f588g9FpG7lotFw1mtW7NNx8l4H40s6TzJdCO2PaZt05FK8GJTePfcdtxuictLK6IINQjZ4gbqp%7EecYDKLk-FvzLVVJ4R7s4yzsCf3JDvuySPlXh9WpQikvEWRPLoscH%7EHRiOOY1eu0Z2omHNsCb-QTGmzrQVv3Iwr5eSVmmspwlEnMfVzDxA18zL5bcwqNQ__",
      hls: null,
    },
    prayer: {
      id: 10162,
      collection_id: 100,
      title: "Gregorian Chant",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10833,
          prayer_id: 10162,
          guide_id: 71,
          length: "30 min",
          duration: 1800,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 2,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30 min",
      shareable_url: "https://hallow.com/prayers/10162",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10835,
      prayer_id: 10163,
      guide_id: 71,
      length: "30 min",
      duration: 1799,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Chant-Mix.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=q2o3oXPX5ASx98EJ57C6BZmcryD9NPhQGb9LLn2n56h3zYtmrRlJgHOUs%7EeE3fUcGYhz67OS9-OqVvhP21OcUg4hOdA4JRd-ViETQl6BiEKp8xMioBWfJJKdJtkcSxUvI8bhKwJ7RE2tcArTvptkFVRHIsAwf7edDrie0PlICiOC2422LmIsrJfKivlB%7EXnQ0HPeAgarzkiSqe9tvtHcf%7EiDJoBN1khkii2QRL1S7zmh4J5JmW9hUr2NnGzpkpXGJ3yQSEeWttsJf9bUiyZDHgvla%7EfU2Oj73fdlPgFsaKEPMyI4W1pj33w28EVs21QNpLBEQvW2cK27RcwLDdx1zw__",
      hls: null,
    },
    prayer: {
      id: 10163,
      collection_id: 100,
      title: "Mixed Chant",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10835,
          prayer_id: 10163,
          guide_id: 71,
          length: "30 min",
          duration: 1799,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 3,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30 min",
      shareable_url: "https://hallow.com/prayers/10163",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10839,
      prayer_id: 10165,
      guide_id: 71,
      length: "30 min",
      duration: 1805,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Ocean.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=ml%7Eb05imYh%7Ec5L9jCYR-xu2KjdhjYDP6FqF91tG70pjoJMBVWJoI6QtJ1284rubmtuPgmLDaZQtQRVg6MBxrGZKcUdLiQxnPX90aSGDWFlGZJEaFfCNn%7EOU8Cy96caZBcaF7W%7EUHsfNtdtC20s9gOtzUUVI8QOyJG1F7IFHuFnJGUScjMEq3XxhsE44zW1oR3bbWGt%7EXFAHyh7gJKtyDz%7E-LN8SCxVDSH2zPWosGOABieqAqLyUDLyYBt1AsjSb1X5JgKJLQnz8DObLKN70EL9ucgrHB-rgXpwGiNZyRCz5r3mbH97yZSwS54L8q9EvLAVNmlx6VMZFDyPk7mkqvKA__",
      hls: null,
    },
    prayer: {
      id: 10165,
      collection_id: 100,
      title: "Ocean Waves",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10839,
          prayer_id: 10165,
          guide_id: 71,
          length: "30 min",
          duration: 1805,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 4,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30 min",
      shareable_url: "https://hallow.com/prayers/10165",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10831,
      prayer_id: 10161,
      guide_id: 71,
      length: "30 min",
      duration: 1808,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Ambient.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=B9gIXzfzaVPCroJT7qgidtQ0J11JdFeGt2mUNjZVKFyiEKpXrhZG%7E2JjWQMI-t3jFAwCZGKh6kxOgQuyeo0j94ManjqD7PRDhGAUWsmDW6-QJ%7E2nUtRS4GDjHdZaZtJOHB62nO1nZtZbnAXwWqku5wT%7Ef6LfVHSc0EaiUGxuqTaJt0879yn7WUnL-xklKhn1lVtGJNMhCKy82VbHT36iTtgK99iH8KWekqeCkNjiqWSYcVVwj1FPqO6vWOkrfwd%7EQrbqXnF6RDGvWhs1HeQsS3YUkWwGWV%7EYqbi9pO%7E9k3LP4bs6YSSxD23j8j84yBgcIqofJCU2fS2M3hTSHYiKVg__",
      hls: null,
    },
    prayer: {
      id: 10161,
      collection_id: 100,
      title: "Ambient Tones",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10831,
          prayer_id: 10161,
          guide_id: 71,
          length: "30 min",
          duration: 1808,
          paid: false,
        },
        {
          id: 44246,
          prayer_id: 10161,
          guide_id: 71,
          length: "31 min",
          duration: 1888,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 5,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30-31 min",
      shareable_url: "https://hallow.com/prayers/10161",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10837,
      prayer_id: 10164,
      guide_id: 71,
      length: "31 min",
      duration: 1845,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Nature.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=RJwRL9PDth7Ti%7EKAeKBP61dl7-RkptgdkTaYA2MZJ3rHt2i1kLfIjYL9%7EjXi%7EW6i9%7ELGxgazKKz74iI8w7UWko3aVDpTNFm%7EHhrir-mQl2J72JQderrnzK6Al4-JFuAjBR6gXxeM8sVPO9rOgowsIJI3P1gTa8yBmXURsShtRBH8xr1v7Y8uu2kjJ498KkXxwHoMA1OwzwbkC3yxv77vFHrlERBv0UCt76ZND-TM-5bfFa7iWnKi3NHxI4-VsYV9chQuBay5ybE5jUTCDcqgaYRjPIYFFnqANettWa4qSKq5sgwONQ9k4ZyiXupxXyw9SY7QWhMMdFyDEKugx-M66w__",
      hls: null,
    },
    prayer: {
      id: 10164,
      collection_id: 100,
      title: "Nature Sound",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10837,
          prayer_id: 10164,
          guide_id: 71,
          length: "31 min",
          duration: 1845,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 6,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "31 min",
      shareable_url: "https://hallow.com/prayers/10164",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10843,
      prayer_id: 10167,
      guide_id: 71,
      length: "31 min",
      duration: 1845,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/White%20Noise.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=liMFhzuhIRv34ANNJnsfCmP0-0vN0RnFZroix4U1S4bP0Ii0zkL6vDc6ZsANx3vmgvGU1LaT2Ij3s5GkFwgEG-RR8ZQaXW4GEfUHvgQjUksrXlX472ExAgNsO4NxnWCMxPpioH-8zziyWqFB79w%7ElCBKFxs2wEQdqTK1YtJEnbGZ4TnBZ2i-hdWCUQj6hVDC6ktb6Rkj4Ak3zrtVk07mcO4irooPaHJgsZubaPesRuarUa5FUTHLWvsuduvDRqciN9h72asoEtwBGRrelHIR7CtVukA-lgZgE%7EymIcoXnaDSL9nHSOPtfpYIybJuwSxQVG-qFtw%7EPr6c-uAeEn1ZKQ__",
      hls: null,
    },
    prayer: {
      id: 10167,
      collection_id: 100,
      title: "White Noise",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10843,
          prayer_id: 10167,
          guide_id: 71,
          length: "31 min",
          duration: 1845,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 7,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "31 min",
      shareable_url: "https://hallow.com/prayers/10167",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10195,
      prayer_id: 10168,
      guide_id: 71,
      length: "31 min",
      duration: 1846,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Bells.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=XfDXv2N5u7KqTV43cIX-tPIVU1o9DR8St4aycK9ILr6uXNFENII0pIzagCM07pR-lRQ0G4Y30QqVPe6RIAole8J4envlGW0ufNvBbMLwNkbXBkBkJxipD8WcXX%7E3Tj8hDtA806CardPAt7VQU2oyTm9lIovE7JfoRdzhMcfN%7EVDnKNZix54cs2zCc7OZHI6rfz7yDAfr1aF9sFTihAk9fLI2nFQstrHP-RKoHQXSbZfnBnoWira4gITDs%7E0RNpEIMCjNb5Jwm8UnpMF0jJ5I6uK%7E9YgLiuqOc0e7TM611kfH6T7HV0d8FgaLow5thVcoPvspAISyG46zdMSe2g-wQg__",
      hls: null,
    },
    prayer: {
      id: 10168,
      collection_id: 100,
      title: "Church Bells",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10195,
          prayer_id: 10168,
          guide_id: 71,
          length: "31 min",
          duration: 1846,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 8,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "31 min",
      shareable_url: "https://hallow.com/prayers/10168",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
  {
    selected_audio: {
      id: 10197,
      prayer_id: 10169,
      guide_id: 71,
      length: "30 min",
      duration: 1826,
      pauses: [],
      paid: false,
      intro_ends_at: null,
      resumes_at: null,
      resumes_session_id: null,
      bg_sounds_enabled: true,
      speed_changes_enabled: true,
      show_music_controls: false,
      url: "https://audio-dev.hallow.app/Rain.m4a?Expires=1712978908&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=WwQ-oqfctr1Y9TFx5yRHHgGD2A3OMSdtJ9FybHAyfU9pgUUPzXXzefesgC7-NImD9sHPqIXxeVThLZbc6smq4raiSiyDTU5Jx1bdKhPNJofhzxdRJuLitOtTsMNvcRHxTuPdZehksTznYpGLDCTkMc63YcLiyCsaTFJQyVq9uIehWAJoawPW57eBpEaEEy2QmSmbA-rqhiKsnKlK3LL2V7uWr1%7E88HcBT%7Ee6Pbb4jblHpSlIpmS0L4UYFjWziqZV9bA0iPXU5Cg5GqVfFypRAMh3nATBxV1jFoF2k38gItXvvOYp4IxCHhpvrnIoy3ROP8%7Ep8GLvp4wClFAGmaRKqQ__",
      hls: null,
    },
    prayer: {
      id: 10169,
      collection_id: 100,
      title: "Gentle Rain",
      supertitle: "Prayer Sounds",
      label_desc: "Background Track",
      detailed_desc:
        "Enjoy this track as an unguided meditation session. Also feel free to download this track to have it available as background music for any prayers you listen to offline in the future.",
      is_song: false,
      is_available: true,
      shareable_quote: null,
      tracks: [
        {
          id: 10197,
          prayer_id: 10169,
          guide_id: 71,
          length: "30 min",
          duration: 1826,
          paid: false,
        },
      ],
      guides: [
        {
          id: 71,
          name: "Unguided",
          tagline: "Background for prayer",
          image_url: "https://images.hallow.app/guides/default_150.png",
          desc: "There is no voice guide for this session. Enjoy these tracks as unguided meditation sessions.",
          deeplink: null,
          images: {
            small: "https://images.hallow.app/guides/default_150.png",
            medium: "https://images.hallow.app/guides/default_150.png",
            large: "https://images.hallow.app/guides/default_150.png",
            color_hex: "#000000",
          },
          sample_audio_url: null,
        },
      ],
      order: 9,
      prompt: null,
      is_redeemed: false,
      is_download_enabled: true,
      is_completed: false,
      is_favorite: false,
      has_access: true,
      lengths: "30 min",
      shareable_url: "https://hallow.com/prayers/10169",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
    },
    collection: {
      id: 100,
      title: "Background Sounds",
      supertitle: "INSTRUMENTAL",
      desc: "These sessions contain only background tracks for unguided meditation. Additionally, if you download any of these tracks, they will be available as background music for any prayers you complete offline in the future.",
      short_desc: "For Unguided Prayer",
      is_album: false,
      prayers_count: 9,
      paid: false,
      has_high_res_illo: false,
      has_access: true,
      is_completed: false,
      sessions: "9 sessions",
      images: {
        small: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_s.png",
        medium: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_m.png",
        large: "https://d3tv5g0y9izdfo.cloudfront.net/covers/100_l.png",
        color_hex: "#000000",
      },
      type: "default",
      available_at: null,
      ends_at: null,
    },
  },
];

export const MOCK_BIBLE_MANIFEST: BibleManifest = {
  translation_id: 1,
  translation_name: "NRSV",
  translation_language: "en",
  translation_description:
    "USCCB approved Catholic translation used in Hallow's Daily Mass Readings and various prayers on the app",
  translation_copyright:
    "Scripture quotations are from the New Revised Standard Version Bible: Catholic Edition, copyright © 1989, 1993 National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved worldwide.",
  translation_version: "2.0",
  books: [
    {
      id: "Gen",
      name: "Genesis",
      testament: "old",
      chapter_count: 50,
      numeric_id: 1,
    },
    {
      id: "Exo",
      name: "Exodus",
      testament: "old",
      chapter_count: 40,
      numeric_id: 2,
    },
    {
      id: "Lev",
      name: "Leviticus",
      testament: "old",
      chapter_count: 27,
      numeric_id: 3,
    },
    {
      id: "Num",
      name: "Numbers",
      testament: "old",
      chapter_count: 36,
      numeric_id: 4,
    },
    {
      id: "Deu",
      name: "Deuteronomy",
      testament: "old",
      chapter_count: 34,
      numeric_id: 5,
    },
    {
      id: "Jos",
      name: "Joshua",
      testament: "old",
      chapter_count: 24,
      numeric_id: 6,
    },
    {
      id: "Jdg",
      name: "Judges",
      testament: "old",
      chapter_count: 21,
      numeric_id: 7,
    },
    {
      id: "Rut",
      name: "Ruth",
      testament: "old",
      chapter_count: 4,
      numeric_id: 8,
    },
    {
      id: "1Sa",
      name: "1 Samuel",
      testament: "old",
      chapter_count: 31,
      numeric_id: 9,
    },
    {
      id: "2Sa",
      name: "2 Samuel",
      testament: "old",
      chapter_count: 24,
      numeric_id: 10,
    },
    {
      id: "1Ki",
      name: "1 Kings",
      testament: "old",
      chapter_count: 22,
      numeric_id: 11,
    },
    {
      id: "2Ki",
      name: "2 Kings",
      testament: "old",
      chapter_count: 25,
      numeric_id: 12,
    },
    {
      id: "1Ch",
      name: "1 Chronicles",
      testament: "old",
      chapter_count: 29,
      numeric_id: 13,
    },
    {
      id: "2Ch",
      name: "2 Chronicles",
      testament: "old",
      chapter_count: 36,
      numeric_id: 14,
    },
    {
      id: "Ezr",
      name: "Ezra",
      testament: "old",
      chapter_count: 10,
      numeric_id: 15,
    },
    {
      id: "Neh",
      name: "Nehemiah",
      testament: "old",
      chapter_count: 13,
      numeric_id: 16,
    },
    {
      id: "Tob",
      name: "Tobit",
      testament: "old",
      chapter_count: 14,
      numeric_id: 70,
    },
    {
      id: "Jdt",
      name: "Judith",
      testament: "old",
      chapter_count: 16,
      numeric_id: 71,
    },
    {
      id: "Est",
      name: "Esther",
      testament: "old",
      chapter_count: 16,
      numeric_id: 17,
    },
    {
      id: "1Ma",
      name: "1 Maccabees",
      testament: "old",
      chapter_count: 16,
      numeric_id: 72,
    },
    {
      id: "2Ma",
      name: "2 Maccabees",
      testament: "old",
      chapter_count: 15,
      numeric_id: 73,
    },
    {
      id: "Job",
      name: "Job",
      testament: "old",
      chapter_count: 42,
      numeric_id: 18,
    },
    {
      id: "Psa",
      name: "Psalms",
      testament: "old",
      chapter_count: 150,
      numeric_id: 19,
    },
    {
      id: "Pro",
      name: "Proverbs",
      testament: "old",
      chapter_count: 31,
      numeric_id: 20,
    },
    {
      id: "Ecc",
      name: "Ecclesiastes",
      testament: "old",
      chapter_count: 12,
      numeric_id: 21,
    },
    {
      id: "Sng",
      name: "Song of Solomon",
      testament: "old",
      chapter_count: 8,
      numeric_id: 22,
    },
    {
      id: "Wis",
      name: "Wisdom of Solomon",
      testament: "old",
      chapter_count: 19,
      numeric_id: 76,
    },
    {
      id: "Sir",
      name: "Sirach",
      testament: "old",
      chapter_count: 51,
      numeric_id: 77,
    },
    {
      id: "Isa",
      name: "Isaiah",
      testament: "old",
      chapter_count: 66,
      numeric_id: 23,
    },
    {
      id: "Jer",
      name: "Jeremiah",
      testament: "old",
      chapter_count: 52,
      numeric_id: 24,
    },
    {
      id: "Lam",
      name: "Lamentations",
      testament: "old",
      chapter_count: 5,
      numeric_id: 25,
    },
    {
      id: "Bar",
      name: "Baruch",
      testament: "old",
      chapter_count: 6,
      numeric_id: 78,
    },
    {
      id: "Ezk",
      name: "Ezekiel",
      testament: "old",
      chapter_count: 48,
      numeric_id: 26,
    },
    {
      id: "Dan",
      name: "Daniel",
      testament: "old",
      chapter_count: 14,
      numeric_id: 27,
    },
    {
      id: "Hos",
      name: "Hosea",
      testament: "old",
      chapter_count: 14,
      numeric_id: 28,
    },
    {
      id: "Jol",
      name: "Joel",
      testament: "old",
      chapter_count: 3,
      numeric_id: 29,
    },
    {
      id: "Ams",
      name: "Amos",
      testament: "old",
      chapter_count: 9,
      numeric_id: 30,
    },
    {
      id: "Oba",
      name: "Obadiah",
      testament: "old",
      chapter_count: 1,
      numeric_id: 31,
    },
    {
      id: "Jon",
      name: "Jonah",
      testament: "old",
      chapter_count: 4,
      numeric_id: 32,
    },
    {
      id: "Mic",
      name: "Micah",
      testament: "old",
      chapter_count: 7,
      numeric_id: 33,
    },
    {
      id: "Nah",
      name: "Nahum",
      testament: "old",
      chapter_count: 3,
      numeric_id: 34,
    },
    {
      id: "Hab",
      name: "Habakkuk",
      testament: "old",
      chapter_count: 3,
      numeric_id: 35,
    },
    {
      id: "Zep",
      name: "Zephaniah",
      testament: "old",
      chapter_count: 3,
      numeric_id: 36,
    },
    {
      id: "Hag",
      name: "Haggai",
      testament: "old",
      chapter_count: 2,
      numeric_id: 37,
    },
    {
      id: "Zec",
      name: "Zechariah",
      testament: "old",
      chapter_count: 14,
      numeric_id: 38,
    },
    {
      id: "Mal",
      name: "Malachi",
      testament: "old",
      chapter_count: 4,
      numeric_id: 39,
    },
    {
      id: "Mat",
      name: "Matthew",
      testament: "new",
      chapter_count: 28,
      numeric_id: 40,
    },
    {
      id: "Mar",
      name: "Mark",
      testament: "new",
      chapter_count: 16,
      numeric_id: 41,
    },
    {
      id: "Luk",
      name: "Luke",
      testament: "new",
      chapter_count: 24,
      numeric_id: 42,
    },
    {
      id: "Jhn",
      name: "John",
      testament: "new",
      chapter_count: 21,
      numeric_id: 43,
    },
    {
      id: "Act",
      name: "Acts",
      testament: "new",
      chapter_count: 28,
      numeric_id: 44,
    },
    {
      id: "Rom",
      name: "Romans",
      testament: "new",
      chapter_count: 16,
      numeric_id: 45,
    },
    {
      id: "1Co",
      name: "1 Corinthians",
      testament: "new",
      chapter_count: 16,
      numeric_id: 46,
    },
    {
      id: "2Co",
      name: "2 Corinthians",
      testament: "new",
      chapter_count: 13,
      numeric_id: 47,
    },
    {
      id: "Gal",
      name: "Galatians",
      testament: "new",
      chapter_count: 6,
      numeric_id: 48,
    },
    {
      id: "Eph",
      name: "Ephesians",
      testament: "new",
      chapter_count: 6,
      numeric_id: 49,
    },
    {
      id: "Php",
      name: "Philippians",
      testament: "new",
      chapter_count: 4,
      numeric_id: 50,
    },
    {
      id: "Col",
      name: "Colossians",
      testament: "new",
      chapter_count: 4,
      numeric_id: 51,
    },
    {
      id: "1Th",
      name: "1 Thessalonians",
      testament: "new",
      chapter_count: 5,
      numeric_id: 52,
    },
    {
      id: "2Th",
      name: "2 Thessalonians",
      testament: "new",
      chapter_count: 3,
      numeric_id: 53,
    },
    {
      id: "1Ti",
      name: "1 Timothy",
      testament: "new",
      chapter_count: 6,
      numeric_id: 54,
    },
    {
      id: "2Ti",
      name: "2 Timothy",
      testament: "new",
      chapter_count: 4,
      numeric_id: 55,
    },
    {
      id: "Tit",
      name: "Titus",
      testament: "new",
      chapter_count: 3,
      numeric_id: 56,
    },
    {
      id: "Phm",
      name: "Philemon",
      testament: "new",
      chapter_count: 1,
      numeric_id: 57,
    },
    {
      id: "Heb",
      name: "Hebrews",
      testament: "new",
      chapter_count: 13,
      numeric_id: 58,
    },
    {
      id: "Jam",
      name: "James",
      testament: "new",
      chapter_count: 5,
      numeric_id: 59,
    },
    {
      id: "1Pe",
      name: "1 Peter",
      testament: "new",
      chapter_count: 5,
      numeric_id: 60,
    },
    {
      id: "2Pe",
      name: "2 Peter",
      testament: "new",
      chapter_count: 3,
      numeric_id: 61,
    },
    {
      id: "1Jo",
      name: "1 John",
      testament: "new",
      chapter_count: 5,
      numeric_id: 62,
    },
    {
      id: "2Jo",
      name: "2 John",
      testament: "new",
      chapter_count: 1,
      numeric_id: 63,
    },
    {
      id: "3Jo",
      name: "3 John",
      testament: "new",
      chapter_count: 1,
      numeric_id: 64,
    },
    {
      id: "Jud",
      name: "Jude",
      testament: "new",
      chapter_count: 1,
      numeric_id: 65,
    },
    {
      id: "Rev",
      name: "Revelation",
      testament: "new",
      chapter_count: 22,
      numeric_id: 66,
    },
  ] satisfies BibleManifest["books"],
};

export const MOCK_USER = {
  id: 7,
  name: "Harold",
  last_name: "Hallow",
  email: "test3@hallow.app",
  guide: "Francis",
  goal: 0,
  streak: 3,
  longest_streak: 3,
  time_in_prayer: 57,
  sync_health: false,
  sync_journals: false,
  has_seen_plan_message: true,
  notifications_enabled: true,
  timezone: "America/Los_Angeles",
  language: "en",
  background_track_id: 10841,
  adjust_idfa: "",
  appsflyer_id: null,
  prayer_goals: null,
  motives: null,
  sharing_to: null,
  consent: [1, 2, 3],
  favorites: [],
  sessions: [],
  devices: [],
  goals: [],
  daily_quote_notifications: false,
  is_discoverable_by_community: false,
  community_notifications_enabled: false,
  username: "haroldH",
  has_completed_community_onboarding: false,
};

export const MOCK_BIBLE_HTML = `
<section id="ch01001" class="chapter"><h1 class="cn">Genesis 1</h1><div id="topContentLink"></div><section><h2 id="ah01001001" class="ahaft">Six Days of Creation and the Sabbath</h2><p class="pf"><span class="verse-1 verseWrapper"><span id="1" class="ver-f">1</span>&nbsp; In the beginning when God created<a id="rfn01001001-1-a" class="fnref" href="#fn01001001-1-a">a</a> the heavens and the earth,</span> <span class="verse-2 verseWrapper"><span id="2" class="ver">2</span>&nbsp;the earth was a formless void and darkness covered the face of the deep, while a wind from God<a id="rfn01001002-1-b" class="fnref" href="#fn01001002-1-b">b</a> swept over the face of the waters.</span> <span class="verse-3 verseWrapper"><span id="3" class="ver">3</span>&nbsp;Then God said, “Let there be light”; and there was light.</span> <span class="verse-4 verseWrapper"><span id="4" class="ver">4</span>&nbsp;And God saw that the light was good; and God separated the light from the darkness.</span> <span class="verse-5 verseWrapper"><span id="5" class="ver">5</span>&nbsp;God called the light Day, and the darkness he called Night. And there was evening and there was morning, the first day.</span></p><p><span class="verse-6 verseWrapper"><span id="6" class="ver-f">6</span>&nbsp; And God said, “Let there be a dome in the midst of the waters, and let it separate the waters from the waters.”</span> <span class="verse-7 verseWrapper"><span id="7" class="ver">7</span>&nbsp;So God made the dome and separated the waters that were under the dome from the waters that were above the dome. And it was so.</span> <span class="verse-8 verseWrapper"><span id="8" class="ver">8</span>&nbsp;God called the dome Sky. And there was evening and there was morning, the second day.</span></p><p><span class="verse-9 verseWrapper"><span id="9" class="ver-f">9</span>&nbsp; And God said, “Let the waters under the sky be gathered together into one place, and let the dry land appear.” And it was so.</span> <span class="verse-10 verseWrapper"><span id="10" class="ver">10</span>&nbsp;God called the dry land Earth, and the waters that were gathered together he called Seas. And God saw that it was good.</span> <span class="verse-11 verseWrapper"><span id="11" class="ver">11</span>&nbsp;Then God said, “Let the earth put forth vegetation: plants yielding seed, and fruit trees of every kind on earth that bear fruit with the seed in it.” And it was so.</span> <span class="verse-12 verseWrapper"><span id="12" class="ver">12</span>&nbsp;The earth brought forth vegetation: plants yielding seed of every kind, and trees of every kind bearing fruit with the seed in it. And God saw that it was good. </span> <span class="verse-13 verseWrapper"><span id="13" class="ver">13</span>&nbsp;And there was evening and there was morning, the third day.</span></p><p><span class="verse-14 verseWrapper"><span id="14" class="ver-f">14</span>&nbsp; And God said, “Let there be lights in the dome of the sky to separate the day from the night; and let them be for signs and for seasons and for days and years,</span> <span class="verse-15 verseWrapper"><span id="15" class="ver">15</span>&nbsp;and let them be lights in the dome of the sky to give light upon the earth.” And it was so. </span> <span class="verse-16 verseWrapper"><span id="16" class="ver">16</span>&nbsp;God made the two great lights—the greater light to rule the day and the lesser light to rule the night—and the stars.</span> <span class="verse-17 verseWrapper"><span id="17" class="ver">17</span>&nbsp;God set them in the dome of the sky to give light upon the earth, </span> <span class="verse-18 verseWrapper"><span id="18" class="ver">18</span>&nbsp;to rule over the day and over the night, and to separate the light from the darkness. And God saw that it was good.</span> <span class="verse-19 verseWrapper"><span id="19" class="ver">19</span>&nbsp;And there was evening and there was morning, the fourth day.</span></p><p><span class="verse-20 verseWrapper"><span id="20" class="ver-f">20</span>&nbsp; And God said, “Let the waters bring forth swarms of living creatures, and let birds fly above the earth across the dome of the sky.” </span> <span class="verse-21 verseWrapper"><span id="21" class="ver">21</span>&nbsp;So God created the great sea monsters and every living creature that moves, of every kind, with which the waters swarm, and every winged bird of every kind. And God saw that it was good.</span> <span class="verse-22 verseWrapper"><span id="22" class="ver">22</span>&nbsp;God blessed them, saying, “Be fruitful and multiply and fill the waters in the seas, and let birds multiply on the earth.”</span> <span class="verse-23 verseWrapper"><span id="23" class="ver">23</span>&nbsp;And there was evening and there was morning, the fifth day.</span></p><p><span class="verse-24 verseWrapper"><span id="24" class="ver-f">24</span>&nbsp; And God said, “Let the earth bring forth living creatures of every kind: cattle and creeping things and wild animals of the earth of every kind.” And it was so. </span> <span class="verse-25 verseWrapper"><span id="25" class="ver">25</span>&nbsp;God made the wild animals of the earth of every kind, and the cattle of every kind, and everything that creeps upon the ground of every kind. And God saw that it was good.</span></p><p><span class="verse-26 verseWrapper"><span id="26" class="ver-f">26</span>&nbsp; Then God said, “Let us make humankind<a id="rfn01001026-1-c" class="fnref" href="#fn01001026-1-c">c</a> in our image, according to our likeness; and let them have dominion over the fish of the sea, and over the birds of the air, and over the cattle, and over all the wild animals of the earth,<a id="rfn01001026-2-d" class="fnref" href="#fn01001026-2-d">d</a> and over every creeping thing that creeps upon the earth.”</span></p><div class="senseline"><p class="sl"><span class="verse-27 verseWrapper"><span id="27" class="ver">27</span>&nbsp;So God created humankind<a id="rfn01001027-1-e" class="fnref" href="#fn01001027-1-e">e</a> in his image,</span></p><p class="sl1"><span class="verse-27 verseWrapper">in the image of God he created them;<a id="rfn01001027-2-f" class="fnref" href="#fn01001027-2-f">f</a></span></p><p class="sl1"><span class="verse-27 verseWrapper">male and female he created them.</span></p></div><p class="pcon"><span class="verse-28 verseWrapper"><span id="28" class="ver">28</span>&nbsp;God blessed them, and God said to them, “Be fruitful and multiply, and fill the earth and subdue it; and have dominion over the fish of the sea and over the birds of the air and over every living thing that moves upon the earth.”</span> <span class="verse-29 verseWrapper"><span id="29" class="ver">29</span>&nbsp;God said, “See, I have given you every plant yielding seed that is upon the face of all the earth, and every tree with seed in its fruit; you shall have them for food.</span> <span class="verse-30 verseWrapper"><span id="30" class="ver">30</span>&nbsp;And to every beast of the earth, and to every bird of the air, and to everything that creeps on the earth, everything that has the breath of life, I have given every green plant for food.” And it was so.</span> <span class="verse-31 verseWrapper"><span id="31" class="ver">31</span>&nbsp;God saw everything that he had made, and indeed, it was very good. And there was evening and there was morning, the sixth day.</span></p></section><div id="bottomContentLink"></div><div class="copyright">Scripture quotations are from the New Revised Standard Version Bible: Catholic Edition, copyright © 1989, 1993 National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved worldwide.<script>document.querySelector(".copyright").addEventListener("click", (e) => {
    if (e.currentTarget.classList.contains("expanded")) e.currentTarget.classList.remove("expanded");
    else e.currentTarget.classList.add("expanded");
});</script></div></section><div class="notes"><div class="footnote">
          <p class="fn"><a id="fn01001001-1-a" class="fnnum" href="#rfn01001001-1-a">a</a> <span class="bcv">1.1</span> Or <i>when God began to create</i> or <i>In the beginning God created</i></p>
        </div>
<div class="footnote">
          <p class="fn"><a id="fn01001002-1-b" class="fnnum" href="#rfn01001002-1-b">b</a> <span class="bcv">1.2</span> Or <i>while the spirit of God</i> or <i>while a mighty wind</i></p>
        </div>
<div class="footnote">
          <p class="fn"><a id="fn01001026-1-c" class="fnnum" href="#rfn01001026-1-c">c</a> <span class="bcv">1.26</span> Heb&nbsp;<i>adam</i></p>
        </div>
<div class="footnote">
          <p class="fn"><a id="fn01001026-2-d" class="fnnum" href="#rfn01001026-2-d">d</a> <span class="bcv">1.26</span> Syr:&nbsp;Heb <i>and over all the earth</i></p>
        </div>
<div class="footnote">
          <p class="fn"><a id="fn01001027-1-e" class="fnnum" href="#rfn01001027-1-e">e</a> <span class="bcv">1.27</span> Heb&nbsp;<i>adam</i></p>
        </div>
<div class="footnote">
          <p class="fn"><a id="fn01001027-2-f" class="fnnum" href="#rfn01001027-2-f">f</a> <span class="bcv">1.27</span> Heb&nbsp;<i>him</i></p>
        </div></div>
`;

export const MOCK_BIBLE_CSS = `
:root {
    --font-multi: 1.0;
    --light-bg-color: #FFFFFF;
    --dark-bg-color: #030303;
}

* {
    box-sizing: border-box;
}

body {
    padding: 40px 15px 150px;
    color: #030303;
    background-color: var(--light-bg-color, #FFFFFF)
}

.enref, .fnref, .notes, .bk, .ps, .pn {
    display: none;
}

a {
    text-decoration: none;
    color: black;
}

sup {
    line-height: 0;
}

.cn {
    display: flex;
    justify-content: center;

    text-decoration: underline;
    text-underline-offset: 13px;

    margin-top: 50px;
    margin-bottom: 100px;
    font-size: calc(var(--font-multi) * 22px);
    line-height: calc(var(--font-multi) * 22px * 1.2 + 13px); /* include underline offset */
    font-family: "Hallow Moderat Serif", "FreightText", serif;
    font-weight: 400;
    text-align: center;
}

.ver-f, .ver {
    vertical-align: super;
    font-size: calc(var(--font-multi) * 11px);
    color: #7A757E;
    line-height: 0;
    font-style: normal;

    background: transparent;
    transition: background 500ms ease-in-out;
}

.ver {
    margin-left: 3px
}

.ahaft, .ah, h2 {
    font-size: calc(var(--font-multi) * 20px);
    line-height: calc(var(--font-multi) * 24px);
}

.ahaft, .ah, h2, h3, h4, h5, h6 {
    margin-bottom: 0;
    font-family: "Hallow Moderat", "Radial", sans-serif;
    letter-spacing: -1px;
}

h3 {
    font-size: calc(var(--font-multi) * 18px);
    line-height: calc(var(--font-multi) * 22px);
}

h4 {
    font-size: calc(var(--font-multi) * 16px);
    line-height: calc(var(--font-multi) * 19px);
}

h5, h6 {
    font-style: italic;
}

h5 {
    font-size: calc(var(--font-multi) * 15px);
    line-height: calc(var(--font-multi) * 18px);
}

h6 {
    font-size: calc(var(--font-multi) * 14px);
    line-height: calc(var(--font-multi) * 17px);
}

.sl {margin-top:.25em; margin-bottom:.25em;}
.slf {margin-top:.25em; margin-bottom:.25em;}
.sll {margin-left:3em; text-indent:-3em; margin-top:.25em; margin-bottom:1em;}
.sls {margin-left:3em; text-indent:-3em; margin-top:1em; margin-bottom:1em;}
.sl1 {margin-left:1em; margin-top:.25em; margin-bottom:.25em;}
.sl1f {margin-left:3em; text-indent:-2em; margin-top:1em; margin-bottom:.25em;}
.sl1l {margin-left:3em; text-indent:-2em; margin-top:.25em; margin-bottom:1em;}
.sl2 {margin-left:3em; text-indent:-1em; margin-top:.25em; margin-bottom:.25em;}
.sl2l {margin-left:3em; text-indent:-1em; margin-top:.25em; margin-bottom:1em;}
.sl3 {text-align:right; text-indent: -1em; margin-top: .25em; margin-bottom: .25em;}
.sl3f {text-align:right; text-indent: -1em; margin-top:1em; margin-bottom: .25em;}
.sl3l {text-align:right; text-indent: -1em; margin-bottom:1em; margin-top: .25em;}
.sl4 {text-align:center; text-indent: 0; margin-top: .25em; margin-bottom: .25em;}

.acrostic .sll {
    text-indent: 0;
}
.acrostic .sl1l {
    text-indent: 1em;
}

p {
    font-size: calc(var(--font-multi) * 22px);
    line-height: calc(var(--font-multi) * 28px);
    font-family: "Hallow Moderat Serif", "FreightText", serif;
    font-weight: 400;
}

.paft, .pf { /* First paragraph and paragraphs after headings should have reduced top margin */
    margin-block-start: 5px
}

.verseWrapper {
  background: transparent;
  transition: background 500ms ease-in-out;
}

.highlighted {
  background: #F1E7F9;
  transition: none;
}

/*Dark mode*/
.darkMode body {
    color: #FFFFFF;
    background-color: var(--dark-bg-color, #030303);
}

.darkMode .ver-f, .ver {
    color: #928C95;
}

.darkMode .highlighted {
  background: #5B4869;
}

.darkMode a.deeplink {
    color: #FFFFFF;
    background-color: #242228;
}

.darkMode a.deeplink svg {
    stroke: #FFFFFF
}

.darkMode .copyright {
    background: #242228;
    color: #928C95;
}

/*Content links*/

#topContentLink, #bottomContentLink {
  width: 100%;
}

#topContentLink {
  height: 70px;
  max-height: 70px;
}

#topContentLink.noLink {
  max-height: 0;
}

#bottomContentLink {
  font-family: "Hallow Moderat", "Radial", sans-serif;
  font-size: calc(20px * var(--font-multi));
  line-height: calc(24px * var(--font-multi));
  font-weight: 600;
  letter-spacing: -0.02em;
}

#bottomContentLink a {
  margin-top: 10px;
  margin-bottom: 30px;
}

a.deeplink {
  color: #030303;
  background-color: #F6F5F8;
  text-decoration: none;
  display: grid;
  padding: 10px;
  grid-template-areas:
    "img-1 title arrow-1"
    "img-2 desc arrow-2";
  border-radius: 12px;
  grid-template-columns: 50px 1fr 17px;
  grid-template-rows: 22px 22px; /* because of the row-gap */
  column-gap: 15px;
  row-gap: 6px;
  width: 100%;
  height: 70px;
  opacity: 0;
  transition: opacity 500ms ease-in-out
}

a.deeplink .image {
  grid-area: img-1 / img-1 / img-2 / img-2;
  overflow: hidden;
  height: 50px;
  border-radius: 6px;
}

a.deeplink .image img {
  object-fit: cover;
  height: 100%;
  object-position: center center;
  width: 100%;
}

a.deeplink h1 {
  grid-area: title;
  justify-self: start;
  align-self: end;
  font-family: "Hallow Moderat", "Radial", sans-serif;
  font-weight: 400;
  font-size: 17px;
  line-height: 20px;
  letter-spacing: -0.02em;
  margin: 0;
  margin-block: 0;
  margin-inline: 0;

  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

a.deeplink .desc {
  grid-area: desc;
  place-self: start;
  opacity: 0.6;
  font-family: "Hallow Moderat", "Neue Montreal", sans-serif;
  font-size: 13px;
  line-height: 15px;
  font-weight: 400;

  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

a.deeplink svg {
  grid-area: arrow-1 / arrow-1 / arrow-2 / arrow-2;
  justify-self: start;
  align-self: center;
  stroke: #030303
}

a.deeplink.visible {
    opacity: 1;
}

.copyright {
    display: block;
    flex-direction: row;
    flex-wrap: nowrap;
    place-content: center;
    place-items: center;
    padding: 16px 24px;
    margin: 40px 16px 0;
    border-radius: 40px;

    background: #F6F5F8;
    color: #7A757E;
    font-family: "Hallow Moderat", "Neue Montreal", sans-serif;
    font-size: calc(var(--font-multi) * 13px);
    line-height: calc(var(--font-multi) * 15px);

    box-sizing: content-box;
    height: calc(var(--font-multi) * 15px); /* 1 line-height */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.copyright.expanded {
    height: auto;
    white-space: normal;
}

.right {
    display: block;
    text-align: right;
    float: right;
    font-style: italic;
}

.left {
    display: block;
    float: left;
    font-style: italic;
    margin-left: -3em;
}

.emphasized {
    font-style: italic;
}

.bksect {
    font-family: "Hallow Moderat", "Neue Montreal", sans-serif;
    font-weight: 400;
    font-size: calc(13px * var(--font-multi));
    line-height: calc(16px * var(--font-multi));
    letter-spacing: -0.26px;
    text-align: center;
    margin: 0;
}

.hidden {
    display: none !important;
}


/* Right-to-Left Handling */
.rtl {
    direction: rtl;
    text-align: right;
}

.rtl .right {
    text-align: left;
    float: left;
}

.rtl .left {
    float: right;
    margin-left: unset;
    margin-right: -3em;
}

.rtl .ver {
    margin-left: unset;
    margin-right: 3px;
}

.rtl .sll {margin-left: unset; margin-right:3em;  }
.rtl .sls {margin-left: unset; margin-right:3em;  }
.rtl .sl1 {margin-left: unset; margin-right:1em;  }
.rtl .sl1f {margin-left: unset; margin-right:3em;  }
.rtl .sl1l {margin-left: unset; margin-right:3em;  }
.rtl .sl2 {margin-left: unset; margin-right:3em;  }
.rtl .sl2l {margin-left: unset; margin-right:3em;  }

h3.cs {
    font-family: "Hallow Moderat Serif", FreightText, serif;
    font-weight: normal;
    font-size: calc(var(--font-multi) * 22px);
    line-height: calc(var(--font-multi) * 28px);
    font-style: italic;
}`;

export const MOCK_BIBLE_TRANSLATIONS: BibleTranslations["translations"] = [
  {
    id: 1,
    name: "NRSV",
    description:
      "USCCB approved Catholic translation used in Hallow's Daily Mass Readings and various prayers on the app",
    language: "en",
    available: true,
    version: "1.7",
    url: "https://bible-dev.hallow.app/translations/1.zip",
  },
  {
    id: 2,
    name: "NABRE",
    description:
      "USCCB approved Catholic translation used in the daily readings at Mass and Hallow's Daily Reflections & Daily Gospel",
    language: "en",
    available: true,
    version: "1.20",
    url: "https://bible-dev.hallow.app/translations/2.zip",
  },
  {
    id: 3,
    name: "DHH",
    description:
      "La versión Dios Habla Hoy está aprobada por El Consejo Episcopal Latinoamericano (CELAM) y es una de las Biblias más utilizadas en América Latina.",
    language: "es",
    available: true,
    version: "1.11",
    url: "https://bible-dev.hallow.app/translations/3.zip",
  },
  {
    id: 4,
    name: "Ave-Maria",
    description:
      "A Bíblia Ave-Maria é a primeira Bíblia católica publicada no Brasil. Com sua linguagem acessível, conquistou os lares brasileiros e, até hoje, é a Bíblia mais popular e querida entre os católicos do país.",
    language: "pt",
    available: true,
    version: "2.2",
    url: "https://bible-dev.hallow.app/translations/4.zip",
  },
  {
    id: 5,
    name: "MBB",
    description:
      "Ang ginamit na salin ng Biblia ay ang Magandang Balita Biblia - Catholic Edition ©2012 ng Philippine Bible Society. Ito rin ang gamit ng Simbahang Katolika sa Pilipinas sa pagdiriwang ng liturhiya.",
    language: "tl",
    available: true,
    version: "1.2",
    url: "https://bible-dev.hallow.app/translations/5.zip",
  },
  {
    id: 6,
    name: "GNB",
    description:
      "Die Gute Nachricht Bibel ist klar, verständlich und interkonfessionell erprobt. Bis heute gehört sie zu den einflussreichsten und am meisten verbreiteten modernen Bibelübersetzungen in deutscher Sprache.",
    language: "de",
    available: true,
    version: "1.20",
    url: "https://bible-dev.hallow.app/translations/6.zip",
  },
  {
    id: 7,
    name: "ESP",
    description:
      "Teksty biblijne za: Pismo Święte Starego i Nowego Testamentu. Najnowszy przekład z języków oryginalnych z komentarzem. © Edycja Świętego Pawła, Częstochowa, PL, 2011. www.pismoswiete.pl Wykorzystano za zgodą właściciela praw.",
    language: "pl",
    available: true,
    version: "1.20",
    url: "https://bible-dev.hallow.app/translations/7.zip",
  },
  {
    id: 8,
    name: "RSVCE",
    description:
      "USCCB approved Catholic translation widely used by many Catholics today ",
    language: "en",
    available: true,
    version: "1.3",
    url: "https://bible-dev.hallow.app/translations/8.zip",
  },
  {
    id: 9,
    name: "PEV",
    description:
      "La Parola è Vita (Italian Contemporary New Testament) Copyright © 1981–1994 by Biblica, Inc.® Used by permission of Biblica, Inc.® All rights reserved worldwide.",
    language: "it",
    available: true,
    version: "1.1",
    url: "https://bible-dev.hallow.app/translations/9.zip",
  },
  {
    id: 10,
    name: "HFA",
    description:
      "Hoffnung für alle® (Hope for all) Copyright © 1983, 1996, 2002, 2015 by Biblica, Inc.® Used by Permission of Biblica, Inc.® All rights reserved worldwide.",
    language: "de",
    available: true,
    version: "1.2",
    url: "https://bible-dev.hallow.app/translations/10.zip",
  },
  {
    id: 11,
    name: "BDS",
    description:
      "La Bible du Semeur® Texte copyright © 1992, 1999, 2015 Biblica, Inc.® Utilisé avec la permission de Biblica, Inc.® Tous droits réservés.",
    language: "fr",
    available: true,
    version: "1.2",
    url: "https://bible-dev.hallow.app/translations/11.zip",
  },
  {
    id: 12,
    name: "HCV",
    description:
      "पवित्र बाइबिल, हिंदी समकालीन संस्करण © 1978, 2009, 2016, 2019 Biblica, Inc.® Biblica, Inc.® की अनुमति से उपयोग किया जाता है. दुनिया भर में आरक्षित सभी अधिकार.",
    language: "hi",
    available: true,
    version: "1.2",
    url: "https://bible-dev.hallow.app/translations/12.zip",
  },
  {
    id: 13,
    name: "NAV",
    description:
      "ا‫لكتاب المقدس، كتاب الحياة ح‫قوق الطبع © 1988، 1997، 2012 Biblica, Inc.®‎ ج‫ميع الحقوق محفوظة في جميع أنحاء العالم، مستخدم بإذن من الناشر",
    language: "ar",
    available: true,
    version: "1.2",
    url: "https://bible-dev.hallow.app/translations/13.zip",
  },
];

export const MOCK_TRANSCRIPT = {
  transcript: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Magna etiam tempor orci eu lobortis elementum nibh tellus molestie. Lectus arcu bibendum at varius vel pharetra vel turpis. Integer vitae justo eget magna fermentum. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Sed velit dignissim sodales ut eu sem integer vitae. Donec massa sapien faucibus et molestie. Eget magna fermentum iaculis eu non. Netus et malesuada fames ac turpis egestas maecenas. Consequat ac felis donec et odio pellentesque diam volutpat commodo. Vel elit scelerisque mauris pellentesque pulvinar pellentesque habitant. Etiam dignissim diam quis enim lobortis scelerisque. Nec dui nunc mattis enim. Amet tellus cras adipiscing enim eu. Justo laoreet sit amet cursus. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Dui faucibus in ornare quam viverra orci sagittis eu volutpat. Nullam non nisi est sit.

Quis eleifend quam adipiscing vitae proin sagittis nisl. Cursus vitae congue mauris rhoncus aenean. Feugiat scelerisque varius morbi enim nunc faucibus a pellentesque. Lectus vestibulum mattis ullamcorper velit. Arcu bibendum at varius vel pharetra vel. Eget mi proin sed libero enim sed faucibus turpis in. Dolor magna eget est lorem ipsum dolor sit. Accumsan sit amet nulla facilisi morbi tempus iaculis urna. Integer feugiat scelerisque varius morbi enim nunc faucibus a. Quis lectus nulla at volutpat diam.

Blandit massa enim nec dui. Malesuada fames ac turpis egestas maecenas. Consectetur lorem donec massa sapien faucibus et molestie ac feugiat. Netus et malesuada fames ac turpis egestas sed tempus. Etiam dignissim diam quis enim lobortis scelerisque. Massa massa ultricies mi quis hendrerit dolor magna. Cursus metus aliquam eleifend mi in. Pretium nibh ipsum consequat nisl vel pretium lectus quam id. Quam elementum pulvinar etiam non. Aenean euismod elementum nisi quis eleifend quam. Tempor nec feugiat nisl pretium fusce id velit ut tortor. Quis auctor elit sed vulputate mi sit amet. Non nisi est sit amet facilisis magna. Sit amet cursus sit amet dictum sit. Tincidunt id aliquet risus feugiat. Mattis aliquam faucibus purus in massa tempor nec feugiat. Leo vel orci porta non pulvinar neque laoreet suspendisse. Ullamcorper sit amet risus nullam eget. Nunc mi ipsum faucibus vitae. In nibh mauris cursus mattis molestie a iaculis at erat.

Rhoncus est pellentesque elit ullamcorper dignissim cras tincidunt lobortis. Ultrices sagittis orci a scelerisque. Nunc sed velit dignissim sodales. Consectetur purus ut faucibus pulvinar elementum integer enim. Lobortis mattis aliquam faucibus purus in massa. Donec ultrices tincidunt arcu non sodales neque. Nunc aliquet bibendum enim facilisis gravida neque convallis a. Enim ut sem viverra aliquet. Pharetra diam sit amet nisl suscipit adipiscing bibendum est. Mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Eget nunc scelerisque viverra mauris in aliquam. Viverra accumsan in nisl nisi scelerisque eu ultrices. Nunc sed blandit libero volutpat sed cras ornare arcu. Condimentum mattis pellentesque id nibh tortor id aliquet. Quisque sagittis purus sit amet. Mauris vitae ultricies leo integer. Maecenas volutpat blandit aliquam etiam erat. Adipiscing vitae proin sagittis nisl rhoncus mattis rhoncus. Condimentum id venenatis a condimentum. Aliquam sem fringilla ut morbi.

Imperdiet nulla malesuada pellentesque elit eget. Massa vitae tortor condimentum lacinia quis vel eros donec ac. Tempus quam pellentesque nec nam aliquam sem et. Vitae et leo duis ut diam. Egestas integer eget aliquet nibh. Malesuada bibendum arcu vitae elementum curabitur vitae nunc sed. Dapibus ultrices in iaculis nunc sed. Ultrices mi tempus imperdiet nulla malesuada pellentesque elit eget gravida. Enim tortor at auctor urna nunc id cursus metus aliquam. Et pharetra pharetra massa massa ultricies mi quis hendrerit.

Arcu cursus euismod quis viverra nibh cras. Sit amet luctus venenatis lectus magna fringilla urna. Ac auctor augue mauris augue neque gravida. Volutpat lacus laoreet non curabitur gravida arcu ac tortor dignissim. Curabitur vitae nunc sed velit dignissim sodales ut. At imperdiet dui accumsan sit amet. Amet venenatis urna cursus eget nunc. Adipiscing elit duis tristique sollicitudin nibh. Aenean pharetra magna ac placerat vestibulum. At lectus urna duis convallis convallis tellus id interdum. Faucibus vitae aliquet nec ullamcorper sit amet risus. Orci nulla pellentesque dignissim enim sit amet venenatis.

Dolor magna eget est lorem ipsum dolor sit amet. Etiam erat velit scelerisque in. Odio aenean sed adipiscing diam donec. Diam quam nulla porttitor massa id neque aliquam vestibulum morbi. Suspendisse in est ante in nibh mauris cursus. Scelerisque viverra mauris in aliquam sem fringilla. Leo vel orci porta non pulvinar neque laoreet suspendisse interdum. Enim neque volutpat ac tincidunt vitae semper. Id porta nibh venenatis cras sed felis eget velit aliquet. Senectus et netus et malesuada fames. Commodo nulla facilisi nullam vehicula ipsum a. Feugiat vivamus at augue eget arcu dictum varius duis at. Euismod quis viverra nibh cras pulvinar. Mattis aliquam faucibus purus in massa tempor nec feugiat. Semper viverra nam libero justo laoreet sit amet cursus.

Proin libero nunc consequat interdum varius sit amet mattis vulputate. Non arcu risus quis varius quam quisque id diam. Aliquam id diam maecenas ultricies mi eget. Morbi quis commodo odio aenean. Morbi tristique senectus et netus et malesuada fames. Aliquet porttitor lacus luctus accumsan. Lobortis feugiat vivamus at augue eget arcu. Urna et pharetra pharetra massa massa ultricies. Eu scelerisque felis imperdiet proin fermentum leo. Ut lectus arcu bibendum at varius vel pharetra. Consequat semper viverra nam libero justo laoreet sit amet. Libero nunc consequat interdum varius sit amet. Imperdiet dui accumsan sit amet nulla.

Nunc sed id semper risus. Vitae sapien pellentesque habitant morbi. Ipsum dolor sit amet consectetur adipiscing. Maecenas accumsan lacus vel facilisis volutpat est velit egestas dui. Faucibus interdum posuere lorem ipsum dolor sit amet consectetur. Mi sit amet mauris commodo quis. Blandit aliquam etiam erat velit scelerisque in dictum non. Phasellus egestas tellus rutrum tellus. Ac odio tempor orci dapibus ultrices. Lobortis feugiat vivamus at augue eget. Volutpat est velit egestas dui id ornare arcu odio. Vestibulum rhoncus est pellentesque elit. Volutpat commodo sed egestas egestas fringilla phasellus faucibus scelerisque. Diam maecenas ultricies mi eget mauris. Id neque aliquam vestibulum morbi blandit cursus. Eget felis eget nunc lobortis mattis aliquam faucibus purus in. Nunc non blandit massa enim nec dui nunc mattis.

Suspendisse sed nisi lacus sed viverra tellus in hac. Nibh ipsum consequat nisl vel pretium lectus quam. Sit amet nulla facilisi morbi tempus iaculis. Tristique senectus et netus et malesuada fames ac turpis. Lectus vestibulum mattis ullamcorper velit. Dignissim enim sit amet venenatis urna cursus eget nunc. Non nisi est sit amet. Risus nec feugiat in fermentum posuere urna nec. At urna condimentum mattis pellentesque id. Sed adipiscing diam donec adipiscing tristique. Nunc sed id semper risus in hendrerit. Morbi tempus iaculis urna id. Vitae semper quis lectus nulla at volutpat diam.

Erat pellentesque adipiscing commodo elit. Ut venenatis tellus in metus vulputate eu scelerisque felis imperdiet. Velit aliquet sagittis id consectetur purus ut faucibus pulvinar. Nibh sit amet commodo nulla facilisi nullam vehicula ipsum a. At elementum eu facilisis sed odio morbi quis. Cursus euismod quis viverra nibh cras. Ut faucibus pulvinar elementum integer. Aliquet sagittis id consectetur purus ut. Senectus et netus et malesuada fames ac turpis. Nullam vehicula ipsum a arcu cursus. Blandit turpis cursus in hac habitasse platea dictumst. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget arcu. Dolor sit amet consectetur adipiscing elit duis. Nunc lobortis mattis aliquam faucibus purus in. Condimentum mattis pellentesque id nibh tortor. Nunc sed velit dignissim sodales ut.

Lorem mollis aliquam ut porttitor leo a diam sollicitudin. Gravida rutrum quisque non tellus orci ac auctor augue mauris. Euismod quis viverra nibh cras pulvinar mattis nunc. Enim ut tellus elementum sagittis vitae et leo. Sit amet risus nullam eget felis eget nunc. Mi bibendum neque egestas congue quisque egestas. Platea dictumst quisque sagittis purus sit amet volutpat consequat. In fermentum et sollicitudin ac orci phasellus egestas. Fermentum iaculis eu non diam phasellus. Ut etiam sit amet nisl purus in mollis.`,
};

export const MOCK_PRAYER = {
  collection_id: 1438,
  detailed_desc: "-",
  selected_track_id: 1037204,
  selected_guide_id: 1,
  show_guide_selection: true,
  challenge_id: null,
  collection: {
    available_at: null,
    desc: "Join us this upcoming Lenten season as we follow Christ and deepen our relationship with Him. Stay tuned for exciting announcements about our Pray40 theme and the guests who'll be leading us in prayer and meditation.",
    ends_at: null,
    has_access: true,
    has_high_res_illo: true,
    has_joined: null,
    id: 1438,
    images: {
      color_hex: "#2B1232",
      large: "https://images.hallow.app/covers/1438_l.webp",
      medium: null,
      small: null,
    },
    is_album: false,
    is_completed: false,
    paid: true,
    prayers_count: 47,
    sessions: "47 sessions",
    short_desc: "Lent Pray40 Challenge",
    supertitle: "CHALLENGES",
    title: "Lent Pray40",
    type: "collection",
  },
  guides: [
    {
      deeplink: null,
      desc: "Abby is a founding member of Hallow, a wife, and a mother.",
      id: 1,
      image_url: "https://images.hallow.app/guides/abby_150.png",
      images: {
        large: null,
        medium: null,
        small: "https://images.hallow.app/guides/abby_150.png",
      },
      name: "Abby",
      sample_audio_url: null,
      tagline: "Casual and Warm",
    },
    {
      deeplink: null,
      desc: "Francis is a founding member of Hallow and has five years of seminary formation.",
      id: 2,
      image_url: "https://images.hallow.app/guides/francis_150.png",
      images: {
        large: null,
        medium: null,
        small: "https://images.hallow.app/guides/francis_150.png",
      },
      name: "Francis",
      sample_audio_url:
        "https://audio-dev.hallow.app/Samples%20-%20F.mp3?Expires=1708067526&Key-Pair-Id=APKAIG2AUVCADBSUVKSQ&Signature=HqJC8v7Cwfryem3ldUCj99LnwjgqkW6xLJVBwiKVlfWAbNSBl4v9E5xzJnKosiJppLkvkMM3BJ-zz6sLfCST8u%7E4n%7E3SGPt2hzcXI3LJL8AZNKewqi6hX1QnP8cMG4lUC-kZWsKJ8I%7ErSQnesGr%7ELwHlX3EgAxzFFwqRyQFhANClLuPb%7EFC3mqX0lwqqnwk2N62X8cxrDAkatm764CjJ9LHJ2K4QAG%7EcyB24y3hkonHtKYxHIkd1g2p8qQf2NjXQCFrH6uyH4KeSX6N-AGZyzDmlOmbNwX8FANpl1mUMhMsKnY8g65tSwuxUn%7EOV6lC6OIGbEpm-P5jX10iOGNhQBQ__",
      tagline: "Deliberate and Calm",
    },
    {
      deeplink: null,
      desc: 'Jonathan is a trained voice actor, who portrays Jesus in the hit TV series "The Chosen."',
      id: 3,
      image_url: "https://images.hallow.app/guides/jonathan_150.png",
      images: {
        large: null,
        medium: null,
        small: "https://images.hallow.app/guides/jonathan_150.png",
      },
      name: "Jonathan",
      sample_audio_url: null,
      tagline: "Heartfelt and Engaging",
    },
  ],
  has_access: true,
  id: 1037204,
  images: {
    color_hex: "#2B1232",
    large: "https://images.hallow.app/covers/1438_l.webp",
    medium: null,
    small: null,
  },
  is_available: true,
  is_completed: false,
  is_download_enabled: true,
  is_favorite: false,
  is_redeemed: false,
  is_song: false,
  label_desc: "Thursday: February 15",
  lengths: "5 min",
  order: 2,
  prompt: "This is an prompt 2",
  shareable_quote: null,
  shareable_url: "https://hallow.com/prayers/1037204",
  supertitle: "CHALLENGES",
  title: "Day 2",
  tracks: [
    {
      duration: 300,
      guide_id: 2,
      id: 94389,
      length: "5 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 300,
      guide_id: 1,
      id: 94390,
      length: "5 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 300,
      guide_id: 3,
      id: 94391,
      length: "5 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 600,
      guide_id: 1,
      id: 94392,
      length: "10 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 600,
      guide_id: 2,
      id: 94393,
      length: "10 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 600,
      guide_id: 3,
      id: 94394,
      length: "10 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 900,
      guide_id: 1,
      id: 94395,
      length: "15 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 900,
      guide_id: 2,
      id: 94396,
      length: "15 min",
      paid: false,
      prayer_id: 1037204,
    },
    {
      duration: 900,
      guide_id: 3,
      id: 94397,
      length: "15 min",
      paid: false,
      prayer_id: 1037204,
    },
  ],
};

export const MOCK_DAILY_READING = {
  liturgical_id: "ordinary_time_12_wednesday_year_2",
  lectionary_name: "Lectionary for Mass",
  lectionary_description: "US Lectionary",
  html: '<!DOCTYPE html><html><body><div class="container"><div class="header"><p class="title">Wednesday of the Twelfth Week in Ordinary Time\n                                                                </p><p class="header-divider"></p><p class="subtitle">Lectionary: 373</p></div><div id="topContentLink"></div><div class="body"><div class="readings-container"><div class="reading-heading"><p class="reading-title">Reading 1 </p><p class="reading-ref">2 Kgs 22:8-13; 23:1-3</p></div><div class="reading-body"><p>The high priest Hilkiah informed the scribe Shaphan, "I have found the book of the law in the temple of the LORD." Hilkiah gave the book to Shaphan, who read it. Then the scribe Shaphan went to the king and reported, "Your servants have smelted down the metals available in the temple and have consigned them to the master workmen in the temple of the LORD." The scribe Shaphan also informed the king that the priest Hilkiah had given him a book, and then read it aloud to the king. When the king heard the contents of the book of the law, he tore his garments and issued this command to Hilkiah the priest, Ahikam, son of Shaphan, Achbor, son of Micaiah, the scribe Shaphan, and the king\'s servant Asaiah: "Go, consult the LORD for me, for the people, for all Judah, about the stipulations of this book that has been found, for the anger of the LORD has been set furiously ablaze against us, because our fathers did not obey the stipulations of this book, nor fulfill our written&nbsp;obligations."</p><p>The king then had all the elders of Judah and of Jerusalem summoned together before him. The king went up to the temple of the LORD with all the men of Judah and all the inhabitants of Jerusalem: priests, prophets, and all the people, small and great. He had the entire contents of the book of the covenant that had been found in the temple of the LORD, read out to them. Standing by the column, the king made a covenant before the LORD that they would follow him and observe his ordinances, statutes and decrees with their whole hearts and souls, thus reviving the terms of the covenant which were written in this book. And all the people stood as participants in the&nbsp;covenant.</p></div></div><div class="divider"></div><div class="readings-container"><div class="reading-heading"><p class="reading-title">Responsorial Psalm </p><p class="reading-ref">Ps 119:33, 34, 35, 36, 37, 40</p></div><div class="reading-body"><p>R.&nbsp;(33a) <strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Instruct me, O LORD, in the way of your&nbsp;statutes,<br>that I may exactly observe&nbsp;them.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Give me discernment, that I may observe your&nbsp;law<br>and keep it with all my&nbsp;heart.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Lead me in the path of your&nbsp;commands,<br>for in it I&nbsp;delight.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Incline my heart to your&nbsp;decrees<br>and not to&nbsp;gain.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Turn away my eyes from seeing what is&nbsp;vain:<br>by your way give me&nbsp;life.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p><p>Behold, I long for your&nbsp;precepts;<br>in your justice give me&nbsp;life.</p><p>R.&nbsp;<strong>Teach me the way of your decrees, O&nbsp;Lord.</strong></p></div></div><div class="divider"></div><div class="readings-container"><div class="reading-heading"><p class="reading-title">Alleluia </p><p class="reading-ref">Jn 15:4a, 5b</p></div><div class="reading-body"><p>R.&nbsp;<strong>Alleluia,&nbsp;alleluia.</strong></p><p>Remain in me, as I remain in you, says the&nbsp;Lord;<br>whoever remains in me will bear much&nbsp;fruit.</p><p>R.&nbsp;<strong>Alleluia,&nbsp;alleluia.</strong></p></div></div><div class="divider"></div><div class="readings-container"><div class="reading-heading"><p class="reading-title">Gospel </p><p class="reading-ref">Mt 7:15-20</p></div><div class="reading-body"><p>Jesus said to his disciples: "Beware of false prophets, who come to you in sheep\'s clothing, but underneath are ravenous wolves. By their fruits you will know them. Do people pick grapes from thornbushes, or figs from thistles? Just so, every good tree bears good fruit, and a rotten tree bears bad fruit. A good tree cannot bear bad fruit, nor can a rotten tree bear good fruit. Every tree that does not bear good fruit will be cut down and thrown into the fire. So by their fruits you will know&nbsp;them."</p></div></div></div><div id="bottomContentLink"></div></div></body></html>',
  top_content_deeplink: {
    id: 1033781,
    title: "Wed Jun 26: Daily Readings",
    description: "June 26th",
    image_url: "https://images.hallow.app/covers/273_m.webp",
    deeplink: "hallow://prayers/1033781",
    color_hex: "#000000",
  },
  bottom_content_deeplink: {
    id: 1037548,
    title: "June 26: Bacon & Spiritual Growth!",
    description: "Daily Reflection: Matthew 7:15-20",
    image_url: "https://images.hallow.app/covers/287_m.webp",
    deeplink: "hallow://prayers/1037548",
    color_hex: "#000000",
  },
};
